module.exports = __webpack_public_path__ + "static/media/setaBranca.c30fceff.svg";